import { useCartContext } from "src/hooks/context/use-cart-context";
import { ShoppingCart } from "src/icons";
import { StyledCartCount, StyledCartLink } from "./Navigation.styled";

function CartButton(): JSX.Element {
  const { totalItems } = useCartContext();

  return (
    <StyledCartLink
      href="/cart"
      prefetch={false}
      data-testid="main-header-cart-a"
    >
      <ShoppingCart width="22" height="24" />
      {totalItems > 0 && (
        <StyledCartCount data-testid="main-header-cart-counter">
          {totalItems}
        </StyledCartCount>
      )}
    </StyledCartLink>
  );
}

export { CartButton };
